<template>
    <div class="app-container">
      <!-- begin app-main -->
      <div class="app-main" id="main">
        <!-- begin container-fluid -->
        <div class="container-fluid">
          <!-- begin row -->
          <div class="row">
            <div class="col-md-12 m-b-30">
              <!-- begin page title -->
              <div class="d-block d-sm-flex flex-nowrap align-items-center">
                <div class="page-title mb-2 mb-sm-0">
                  <h1>Website Settlements</h1>
                </div>
                <div class="ml-auto d-flex align-items-center">
                  <nav>
                    <ol class="breadcrumb p-0 m-b-0">
                      <li class="breadcrumb-item">
                        <a>
                          <i class="ti ti-home"></i>
                        </a>
                      </li>
                      <li class="breadcrumb-item">Websites</li>
                      <li class="breadcrumb-item active text-primary" aria-current="page">
                        Settlements
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <!-- end page title -->
            </div>
          </div>
          <!-- end row -->
          <!-- begin row -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card card-statistics">
                <div class="card-body">
                  <Loader v-if="$store.getters.isLoading" />
                  <div v-else class="export-table-wrapper table-responsive">
                 
                    <table id="export-table" class="table table-bordered">
                      <thead class="thead-light">
                        <tr>
                          <th>ID</th>
                          <th>Website Name</th>
                          <th>Sub Domain</th>
                          <th>Domain</th>
                          <th>DNS Record ID</th>
                          <th>Created At</th>
                          <th>Updated At</th>
                        </tr>
                      </thead>
                      <span v-if="websites?.length < 1">No websites available</span>
                      <tbody v-else>
                        <tr v-for="(website, index) in websites" :key="index">
                          <td>{{ website.id }}</td>
                          <td>{{ website.name }}</td>
                          <td>{{ website.sub_domain }}</td>
                          <td>{{ website.domain || "N/A" }}</td>
                          <td>{{ website.dns_record_id }}</td>
                          <td>{{ website.created_at | formatDate }}</td>
                          <td>{{ website.updated_at | formatDate }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <sliding-pagination
                      v-if="websites?.length > 0"
                      :current="currentPage"
                      :total="totalPages"
                      @page-change="pageChangeHandler"
                    ></sliding-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <!-- end container-fluid -->
      </div>
      <!-- end app-main -->
    </div>
  </template>
  
  <script>
  import Swal from "sweetalert2";
  
  export default {
    data() {
      return {
        websites: [],
        interval: null,
        keyword: "",
        currentPage: 1,
        totalPages: 1,
      };
    },
    mounted() {
      this.getWebsites();
    },
    methods: {
      pageChangeHandler(page) {
        this.currentPage = page;
        this.getWebsites();
      },
      getWebsites() {
        this.$store.commit("setLoading", true);
        const link = `${this.$store.getters.baseURL}websites/get_all?page=${this.currentPage}`;
        fetch(link, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.getters.getToken}`,
          },
        })
          .then((res) => res.json())
          .then((result) => {
            if (result.status) {
              this.websites = result.data.data;
              this.currentPage = result.data.current_page;
              this.totalPages = result.data.last_page;

              
            } else {
              Swal.fire({
                icon: "error",
                title: result.message,
              });
            }
            this.$store.commit("setLoading", false);
          })
          .catch((err) => {
            console.log(err);
            Swal.fire({
              icon: "error",
              title: "Check your connection",
            });
            this.$store.commit("setLoading", false);
          });
      },
  

    },
  };
  </script>
  
  <style scoped>
  .table {
    text-align: left;
    font-size: 14px;
  }
  .export-buttons {
    display: flex;
    justify-content: space-between;
  }
  </style>
  